import Navbar from "../components/Navbar";
import WhyIGrade from "../components/WhyIGrade";
import { Footer } from "../components/Footer";

export default function About() {
  return (
    <>
      <Navbar />
      <WhyIGrade />
      <Footer />
    </>
  );
}